import Grid from '@mui/material/Grid';
import Title from "../Shared/Title";

const Row = props => {
    return (
        <Grid container className="ContainerRow">
            <Grid item xs={6}>
                <Title
                    row
                    href={`/users/${props.item.Id}`}
                    icons={props.icons}
                    label={`${props.item.FirstName} ${props.item.LastName}`}
                />
            </Grid>
            <Grid item xs={3}>
                {props.item.Email}
            </Grid>
            <Grid item xs={3} sx={{ justifyContent: 'flex-end' }}>

            </Grid>

        </Grid>
    )
}

export default Row